import { createSelector } from '@ngrx/store'
import { ReportsState } from '../reducers'

const cacheState = (state: ReportsState) => state.cache;

export const getCache = createSelector(cacheState, state => state.entity);
export const getCacheLoaded = createSelector(cacheState, state => state.loaded);
